import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppService } from 'src/app/services/app.service';
import { NegocioItemModalComponent } from '../negocio-item-modal/negocio-item-modal.component';

@Component({
  selector: 'negocio-item',
  templateUrl: './negocio-item.component.html',
  styleUrls: ['./negocio-item.component.scss']
})
export class NegocioItemComponent implements OnInit {

  @Input("data") data:any = null;

  constructor(
    private app: AppService,
    private dialog: MatDialog
  ){}

  /**
   * 
   * Open
   * 
   */
  open(){

    this.dialog.open(
      NegocioItemModalComponent,{
        width: "1000px",
        data: {
          item: this.data
        }
      }
    );

  }
  /**
   * 
   * Open Whats
   * 
   */
  openWhats(){

    let telefone = this.data.empresa_telefone.replace("(","").replace(")","").replace("-","").replace(" ","");

    let numero  = "55"+telefone;
    let prefixo = this.app.isMobile() ? "api" : "web";

    window.open("https://"+prefixo+".whatsapp.com/send?phone="+numero,"__blank");

    return false;

  }
  /***
   * 
   * Init
   * 
   * 
   ***/
  ngOnInit():void{}

}
